<template>
  <sweet-modal ref="modal" icon="warning" hide-close-button class="vld-parent">
    <p>
      <StrongI18n
        :keypath="'modals.row_category_exists'"
        :values="{propName: conflictingName}"
      />
    </p>

    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'ConflictRowCategoryModal',
  components: {
    SweetModal,
    StrongI18n
  },
  computed: {
    ...mapState({
      conflict: state => state.conflict
    }),
    conflictingName() {
      return this.conflict ? this.conflict.name : '';
    }
  },
  methods: {
    close() {
      this.$store.commit('setConflict', {status: false});
    }
  },
  watch: {
    conflict(newValue) {
      if (newValue.status === undefined || !newValue.status) {
        this.$refs.modal.close();
      } else if (newValue.kind === 'rowCategory') {
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
